import { isAgentsOnlyRoute } from '@/features/agents/agents.utils';
import { Routes } from '@/types/routes';
import { AppCapability, isCapable } from '@/utils/capabilities';

export type NavRailPanel =
  | 'chats'
  | 'agents'
  | 'settings'
  | 'library'
  | 'integrations'
  | 'meetings';

const CHAT_PANEL_ROUTES = [Routes.Chats, Routes.Projects];

export const navRailPanelFor = (pathname: string): NavRailPanel | null => {
  if (isAgentsOnlyRoute(pathname)) return 'agents';
  if (pathname.startsWith(Routes.Settings)) return 'settings';
  if (pathname.startsWith(Routes.Sprites)) return 'library';
  if (pathname.startsWith(Routes.Integrations)) return 'integrations';
  if (pathname.startsWith(Routes.Meetings)) {
    return isCapable(AppCapability.MeetingNotes) ? 'meetings' : null;
  }
  if (pathname.startsWith(Routes.Routines)) return 'chats';
  return CHAT_PANEL_ROUTES.some((route) => pathname.startsWith(route))
    ? 'chats'
    : null;
};
